module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMCAYAAAC0qUeeAAAAAXNSR0IArs4c6QAAAU1JREFUKFOFkM1LVAEUxX/nPZ2JtFwMM0UF4qo2RgMtdO0ymF1jbsphFHRXq3Dnwn3QMpDEQPwAF0LLFq0UWrToH5CgSJoGpILevHnvyHs9I7DwwN3c+7vnfohCC7uuhQFzIo9RQ5CVZLoKqT9v6KOyxOxLXyhdZkEpK8DFjCGvAKZrU3/RLODWtqtKeIu5af12PJWgG/eov3pUwA9WfS0c4L1FVf7jiYUxnbTPnc22PufDGqu+VDJbhilM6S/bHvAmFtN7bX3P4fvbDqNvTPRT1jFXgUEgRnxxwMPhCgc7TSVi2cHkMeXydYYMY2HAjFPGFfAhhQ1SDqNP/NwfIdLtZd8YFC2Ju4VjCRFiEiBbIza8i3+wpltL3gnFPUM5f9lZWRAl5rVGn/iXyI/6F3jaakNPtUV/BSrnwYiORub9NE15LHPlf2tYHAXw7ATvSXhvsNnx9AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_user.png
// module id = HzLK
// module chunks = 4